var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { checkIsPlatform, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { Image, View } from 'react-native';
import { getStatusCardImageSectionSizes } from './StatusCardImageSectionStyles';
export var StatusCardImageSection = props => {
  var imageUrl = props.imageUrl,
    size = props.size,
    testID = props.testID,
    imageAccessibilityProps = props.imageAccessibilityProps,
    restProps = __rest(props, ["imageUrl", "size", "testID", "imageAccessibilityProps"]);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var platform = isLargeScreen ? 'web' : 'mobile';
  var imageStyles = getStatusCardImageSectionSizes(platform, size);
  var isSvg = imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.endsWith('.svg');
  if (isSvg && !checkIsPlatform('web')) {
    var SvgUri = require('react-native-svg').SvgUri;
    return _jsx(View, Object.assign({
      style: {
        width: (restProps === null || restProps === void 0 ? void 0 : restProps.width) ? restProps === null || restProps === void 0 ? void 0 : restProps.width : imageStyles.width,
        height: (restProps === null || restProps === void 0 ? void 0 : restProps.height) ? restProps === null || restProps === void 0 ? void 0 : restProps.height : imageStyles.height
      }
    }, {
      children: _jsx(SvgUri, Object.assign({
        uri: imageUrl
      }, imageStyles, restProps, getTestId(testID, 'svgImageUrl')))
    }));
  }
  return _jsx(_Fragment, {
    children: !!imageUrl && _jsx(Image, Object.assign({}, getTestId(testID, 'imageUrl'), {
      source: Object.assign(Object.assign({
        uri: imageUrl
      }, imageStyles), restProps),
      resizeMode: "contain"
    }, imageAccessibilityProps))
  });
};